import DataSource from './DataSource';
import DataModel from './DataModel';

const DataAttributes = ['id', 'show_id', 'dog_id', 'breed_id', 'section', 'report_type' ];
const Defaults = {
  id: '',
  show_id: '',
  dog_id: '',
  breed_id: '',
  section: '',
  report_type: 1,
};

export default class ShowResult extends DataModel {
  static Defaults = Defaults;
  static DataAttributes = DataAttributes;
  static resource = DataSource.getSource('show_results', 'shows/{:show_id}/results{/:id}{/:action}.json', 'show_result');

  constructor(data) {
    super(data);
    this.updateFrom({...this.constructor.Defaults, ...data});
  }

  static saveResults(data) {
    const patch = { action: 'bulk_update', show_id: data.show_id, report_type: data.report_type, breeds: data.breeds};
    return this.resource.update(patch);
  }

}

